import { lightTheme } from '@cnamts/design-tokens/src/colors';

export const themeColors = {
	light: lightTheme
};
